export default "__VITE_ASSET__7dc83767__"